module.exports = __webpack_public_path__ + "static/media/wl.5ded42e0.webp";